export default __webpack_public_path__ + "static/media/Vishwa.dc60343e.png";